import formatNumber from '@/utils/NumberFormatter';

export interface IAudienceImpressionsResultAPI {
  demographic_ids: number[];
  accuracy_percentage_off: number;
  impressions_available: number;
}

export default class AudienceImpressionsResult {
  impressionsAvailable: number;

  accuracyPercentageOff: number;

  demographicIds: number[];

  apiObject?: IAudienceImpressionsResultAPI;

  constructor(impressionsAvailable: number, accuracyPercentageOff: number, demographicIds: number[]) {
    this.impressionsAvailable = impressionsAvailable;
    this.accuracyPercentageOff = accuracyPercentageOff;
    this.demographicIds = demographicIds;
    this.apiObject = null;
  }

  get impressionsAvailableFormatted(): string {
    const audienceImpressionsMin = this.impressionsAvailable * (1 - this.accuracyPercentageOff / 100 / 2);
    const audienceImpressionsMax = this.impressionsAvailable * (1 + this.accuracyPercentageOff / 100 / 2);
    return `${formatNumber(audienceImpressionsMin, '0.0a')} - ${formatNumber(audienceImpressionsMax, '0.0a')}`;
  }

  static fromApi(apiObject: IAudienceImpressionsResultAPI): AudienceImpressionsResult {
    const audienceImpressionsResult = new AudienceImpressionsResult(
      apiObject.impressions_available,
      apiObject.accuracy_percentage_off,
      apiObject.demographic_ids,
    );
    audienceImpressionsResult.apiObject = apiObject;
    return audienceImpressionsResult;
  }
}
